import React from 'react';
import { TableBody, TableRow, TableCell, Paper, Typography } from '@mui/material'; // Import necessary MUI components

const NoMembersFoundMessage = () => (
  <TableBody>
    <TableRow>
      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
        <Paper sx={{ textAlign: 'center' }}>
          <Typography variant="h6" paragraph>
            Not found
          </Typography>

          <Typography variant="body2">There are no members added to this project.</Typography>
        </Paper>
      </TableCell>
    </TableRow>
  </TableBody>
);

export default NoMembersFoundMessage;
